import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { getClassName } from '../../utils/info-helper';
/* styles */
import './empty-content.scss';

class EmptyContent extends React.PureComponent {
    render() {
        return (
            <div className={getClassName('sten-empty-content', this.props.className)}>
                {this.props.children ? (
                    <div className="sten-empty-content__text">{this.props.children}</div>
                ) : <div className="sten-empty-content__text">There is no relevant data.</div>}
            </div>
        );
    }
}

EmptyContent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

EmptyContent.defaultProps = {
    children: null,
    className: ''
};

export default EmptyContent;
